import React from 'react';
import './SingleBlog.scss';
import Navbar from '../../components/Navbar/Navbar';
import { Link, useParams } from 'react-router-dom';
import BlogData from '../../sections/Blogs/BlogData';
import Footer from '../../sections/Footer/Footer';

const SingleBlog = () => {

    const {url} = useParams();
    const blog = BlogData.find(blog => blog.url === url);

    if (!blog) {
        return (
            <>
                <Navbar />
                <section className='section-bg pb-70 single-blog'>
                    <div className="container">
                        <main className="single-blog-area">
                            <h2 className="single-blog-title">İçerik bulunamadı</h2>
                            <p className="single-blog-text">Aradığınız blog yazısı kaldırılmış veya bağlantısı değişmiş olabilir.</p>
                            <Link to="/bloglar">Bloglara geri dön</Link>
                        </main>
                    </div>
                </section>
                <Footer/>
            </>
        );
    }

    const {title, img, category} = blog;

    return (
        <>
            <Navbar />
            <section className='section-bg pb-70 single-blog'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                                <main className="single-blog-area">
                                <p className="single-blog-category">
                                    {category}
                                </p>
                                <h2 className="single-blog-title">{title}</h2>
                                <img className='single-blog-banner' src={img} alt="blog görseli"/>
                                <p className="single-blog-text">Ağız ve diş sağlığında başarılı sonuçların temelinde doğru teşhis, güncel teknoloji ve hastaya özel planlama yer alır. Kliniğimizde her tedavi sürecini kişinin ihtiyaçlarına göre değerlendiriyor, uzun vadeli ağız sağlığını destekleyen çözümler oluşturuyoruz.</p>

                                <p className='single-blog-text'>Erken teşhis edilen problemler genellikle daha kısa sürede ve daha konforlu şekilde tedavi edilebilir. Bu nedenle düzenli kontroller, yalnızca mevcut şikayetleri gidermek için değil, ileride oluşabilecek daha büyük sorunların önüne geçmek için de büyük önem taşır.</p>

                                <blockquote className='single-post-quote'>“Sağlıklı bir gülüş, sadece estetik değil; konforlu konuşma, rahat çiğneme ve günlük yaşam kalitesi için de büyük fark yaratır.”</blockquote>

                                <p className="single-blog-text">Tedavi seçeneklerini belirlerken hastalarımızı tüm aşamalar hakkında açık şekilde bilgilendiriyoruz. Böylece hem süreç daha anlaşılır hale geliyor hem de hasta memnuniyeti artıyor. Siz de ağız ve diş sağlığınızla ilgili doğru yönlendirme almak için düzenli kontrollerinizi ihmal etmeyin.</p>
                            </main>
                        </div>
                        <div className="col-lg-3">
                            <div className="blog-sidebar">
                                <div className="sidebar-subscribe mb-5">
                                    <h3 className="sidebar-heading">Güncel içerikleri kaçırmayın</h3>
                                    <form>
                                        <div className="form-group">
                                            <input type="email" className='form-control' placeholder='E-posta adresinizi girin'/>
                                            <input className='btn btn-primary mt-1 w-100' type="button" value="Abone Ol" />
                                        </div>
                                    </form>
                                </div>

                                <div className="sidebar-category mb-3">
                                    <h3 className="sidebar-heading">Kategoriler</h3>
                                    <ul>
                                        <li><Link to="/bloglar">Teknoloji</Link></li>
                                        <li><Link to="/bloglar">Kanal Tedavisi</Link></li>
                                        <li><Link to="/bloglar">Diş Sağlığı</Link></li>
                                        <li><Link to="/bloglar">Beyazlatma</Link></li>
                                        <li><Link to="/bloglar">Protezler</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer/>
        </>
    );
};

export default SingleBlog;